import { ZoomIn, ZoomOut } from 'assets';
import { FunnelZoomButtonElement } from './FunnelZoomButton.styles';

export default function FunnelZoomButton({ disabled, type, onClick }: FunnelZoomButtonProps) {

    return (
        <FunnelZoomButtonElement
            aria-label={type === 'in' ? 'Zoom in' : 'Zoom out'}
            data-testid={`funnel-zoom-${type}`}
            disabled={disabled}
            onClick={() => onClick(type)}
        >
            {type === 'in' ? <ZoomIn /> : <ZoomOut />}
        </FunnelZoomButtonElement>
    );

}